<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <b-row>
          <b-col sm="4">
            <div class="form-group">
              <label
                      for="exsbitemscategory_name"
                      class="form-control-label">{{$t('views.exsbitemscategories.form.name')}}:</label>
              <input
                      id="exsbitemscategory_name"
                      v-model="item.name"
                      :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                      type="text"
                      required="true"
                      placeholder=""
                      @input="handleUpdateField('name', $event.target.value)">
              <div
                      v-if="isInvalid('name')"
                      class="invalid-feedback">{{ violations.name }}</div>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="form-group">
              <label
                      for="exsbitemscategory_description"
                      class="form-control-label">{{$t('views.exsbitemscategories.form.description')}}:</label>
              <input
                      id="exsbitemscategory_description"
                      v-model="item.description"
                      :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('description', $event.target.value)">
              <div
                      v-if="isInvalid('description')"
                      class="invalid-feedback">{{ violations.description }}</div>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="form-group">
              <label for="customSymbol"
                     class="form-control-label">{{$t('views.exsbitems.form.customSymbol')}}</label>
              <input
                id="customSymbol"
                type="text"
                v-model="item.customSymbol"
                class="form-control"
                @input="handleUpdateField('customSymbol', $event.target.value)">
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
